import { render, staticRenderFns } from "./KTPUpload.vue?vue&type=template&id=d7b662c6&scoped=true&"
import script from "./KTPUpload.vue?vue&type=script&lang=js&"
export * from "./KTPUpload.vue?vue&type=script&lang=js&"
import style0 from "./KTPUpload.vue?vue&type=style&index=0&id=d7b662c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b662c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
